// olap-client/src/components/chat/ContactsTab.jsx
import React from 'react';

const ContactsTab = () => {
  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff'
    }}>
      <div style={{
        padding: '16px',
        borderBottom: '1px solid #e4e4e5',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        Контакты
      </div>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#707579',
        fontSize: '14px'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '10px' }}>👥</div>
          <div>Раздел в разработке</div>
        </div>
      </div>
    </div>
  );
};

export default ContactsTab;